import { Directive, ElementRef, Renderer2, input } from '@angular/core';
import { ADPResourceService } from 'digital-core';

@Directive({
    selector: '[ifSettingFalse]',
    standalone: true,
})
export class SettingFalseDirective {
  constructor(
    public elementRef: ElementRef,
    public renderer: Renderer2,
    public resourceService: ADPResourceService
  ) {}
  readonly ifSettingFalse = input<string>(undefined);

  ngOnInit() {
    let result: boolean;
    let resourceKey = this.ifSettingFalse();
    if (!this.resourceService.getPortalSetting(resourceKey) && !this.resourceService.getViewResourceObject(resourceKey))
    {
      // throw new Error(resourceKey + ' not found in the Portal Settings/Resources');
    }

    if (this.resourceService.getPortalSetting(resourceKey)) {
      result = !this.resourceService.isPortalSettingTrue(resourceKey);
    } else if (this.resourceService.getViewResourceObject(resourceKey)) {
      result = this.resourceService.isFieldVisible(resourceKey);
    }

    if (!result) {
      this.elementRef.nativeElement.setAttribute('style', 'display: none !important');
      // this.elementRef.nativeElement.style.display = 'none';
    }
  }
}
